(ns app.front.view.group.admin.fees.reversal-methods.subs
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.fees.reversal-methods.core :as-alias reversal-methods]
            [app.front.view.group.admin.subs :as gas]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state
  (fn [db]
    (get-in db [::reversal-methods/group-admin :fees :reversal-methods])))

(rf/reg-sub ::expanded-method-id
  :<- [::state]
  :-> :expanded-method-id)

(rf/reg-sub ::adding-new?
  :<- [::state]
  :-> :adding-new?)

(rf/reg-sub ::unsaved-changes
  :<- [::state]
  (fn [state]
    (get state :unsaved-changes {})))

(rf/reg-sub ::has-unsaved-changes?
  :<- [::unsaved-changes]
  (fn [unsaved-changes [_ method-id]]
    (boolean (get unsaved-changes method-id))))

(rf/reg-sub ::methods
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (entities/find-entities ctx {:bill-reversal-method/authority-group group-id
                                 :entity/type                          :entity.type/bill-reversal-method})))

(rf/reg-sub ::form-data
  :<- [::state]
  (fn [state [_ method-id]]
    ;; Get form data (pre-loaded on expand or updated by user)
    (get-in state [:form-data method-id]
            ;; Default for new methods
            {:titles   {}
             :messages {}
             :type     :bill-reversal-method.type/refund})))
